export default {
  namespaced: true,
  state: {
    snackbar: {
      show: false,
      color: '',
      timeout: 6000,
      text: ''
    },
    firstLoginPopup: false,
    acceptTermsDialog: false
  },
  mutations: {
    setSnackbar (state, snackbar) {
      state.snackbar = snackbar
    },
    setFirstLoginPopup (state, firstLoginPopup) {
      state.firstLoginPopup = firstLoginPopup
    },
    setAcceptTermsDialog (state, acceptTermsDialog) {
      state.acceptTermsDialog = acceptTermsDialog
    },
    setSnackbarSuccess (state, title) {
      state.snackbar.show = true
      state.snackbar.color = 'success'
      state.snackbar.text = title
    },
    setSnackbarFailed (state, title) {
      state.snackbar.show = true
      state.snackbar.color = 'error'
      state.snackbar.text = title
    }
  },
  actions: {
    setSnackbar (context, snackbar) {
      context.commit('setSnackbar', snackbar)
    },
    setFirstLoginPopup (context, firstLoginPopup) {
      context.commit('setFirstLoginPopup', firstLoginPopup)
    },
    setAcceptTermsDialog (context, acceptTermsDialog) {
      context.commit('setAcceptTermsDialog', acceptTermsDialog)
    },
    setSnackbarSuccess (context, title) {
      context.commit('setSnackbarSuccess', title)
    },
    setSnackbarFailed (context, title) {
      context.commit('setSnackbarFailed', title)
    }
  }
}
